import axios from 'axios'
import { create } from 'zustand'

const API_SLUG = 'customer'

interface CustomerStore {
  data: any[]
  getAll: (params: any) => Promise<{ success: boolean; data: any }>
  clearState: () => void
}

export const useCustomerStore = create<CustomerStore>(set => ({
  data: [],
  getAll: async params => {
    return axios
      .get(`/${API_SLUG}`, { params })
      .then(res => {
        set({ data: res.data })
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  clearState: () => set({ data: [] }),
}))
